import CommHandler from './CommHandler';

const checkSuperadminStatus = async (email: string): Promise<boolean> => {
  try {
    // Use relative URL - CommHandler already has baseURL configured
    const response = await CommHandler.post('/user/checkSuperadmin', { email });
    return response.data.isSuperadmin;
  } catch (error) {
    console.error('Error checking superadmin status:', error);
    return false;
  }
};

export default checkSuperadminStatus;
